
import { Loader2, User } from "lucide-react";
import { useProfileData } from "@/hooks/useProfileData";
import { ProfileForm } from "@/components/profile/ProfileForm";
import { PreferencesSummary } from "@/components/profile/PreferencesSummary";
import { SubscriptionUsage } from "@/components/profile/SubscriptionUsage";
import { Toaster } from "@/components/ui/toaster";
import PageLayout from "@/components/layout/PageLayout";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Button } from "@/components/ui/button";

const Profile = () => {
  const { profile, setProfile, loading, saving, saveProfile } = useProfileData();
  const { t } = useTranslation("profile");
  const navigate = useNavigate();
  const [isSavingAndNavigating, setIsSavingAndNavigating] = useState(false);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  const handleSaveAndRunAgent = async () => {
    try {
      setIsSavingAndNavigating(true);
      // Wait for the save operation to complete
      await saveProfile(profile);
      console.log("Profile saved successfully, now navigating to tender-agent");
      // Only navigate after the save is successful
      navigate("/tender-agent", { state: { runAgentOnMount: true } });
    } catch (error) {
      console.error("Error saving profile before navigation:", error);
      setIsSavingAndNavigating(false);
      // Navigation will not happen if there's an error with saving
    }
  };

  return (
    <PageLayout
      title={t("title")}
      description={t("description")}
      icon={<User className="h-6 w-6" />}
    >
      <div className="container mx-auto py-8 px-4 animate-fade-up">
        <PreferencesSummary profile={profile} />
        
        {/* Add subscription usage component */}
        <SubscriptionUsage />
        
        <ProfileForm
          profile={profile}
          onProfileChange={setProfile}
          onSave={handleSaveAndRunAgent}
          saving={saving || isSavingAndNavigating}
        />
        <Toaster />
      </div>
    </PageLayout>
  );
};

export default Profile;
